export class Curso {
  id: string;
  nome: string;
  areaConhecimento: string;
  formacao: string;
  turnos: string[];
  duracao: number;
  valorBase: number;
  portaria: string;
  presencial: string;
  campus: {
    id: string,
    descontoPontualidade: string,
    portariaDesconto: string,
    desconto: number,
    idCidade: number,
    nomeCidade: string,
    nome: string,
    turno: string,
    turnos: string[],
  }[];

  gradeCurricular: any;

  _nomeFormatado: string;

  get nomeFormatado(): string {
    return this._nomeFormatado || this.nome;
  }

  gerarNomeFormatado() {
    this._nomeFormatado = this.nome + ' - ' + this.formacao;
  }

  constructor(args) {
    Object.assign(this, args);
  }
}

export class DetalheCurso {
  titulo: string;
  sobre: string;
  ogdescription: string;

  constructor(args) {
    Object.assign(this, args);
  }
}
